import { useAnalytics } from "@lazarentertainment/analytics-collector"
import { useChannelContext } from "client/components/channel"
import { useLayoutContext } from "client/components/layout"
import { Sheet } from "client/designSystem/Sheet"
import { CommerceError } from "client/packages/commerce/utils/components/CommerceError"
import { useGlobalContext } from "client/packages/utils/GlobalContext"
import { useEffect } from "react"
import { ErrorBoundary } from "shared/components/ErrorBoundary"

import { TargetCartProvider } from "./cart/TargetCartContext"
import TargetCommerceFlow from "./TargetCommerceFlow"

import styles from "../../commerce/components/commerceMobileSheet.module.css"

export const TargetMobileSheet = () => {
  const { analytics } = useAnalytics()
  const { channelId, broadcastId, recordingId } = useChannelContext()
  const { layout } = useLayoutContext()
  const {
    state: { isTargetPluginOpen },
  } = useGlobalContext()

  useEffect(() => {
    analytics.identify(undefined, {
      channelId,
      broadcastId,
      recordingId,
    })
  }, [])

  return (
    <Sheet
      open={isTargetPluginOpen}
      data-layout={layout}
      className={styles.commerceSheet}
    >
      <div className={styles.commerceMobileSheetContent}>
        <TargetCartProvider>
          <ErrorBoundary fallback={<CommerceError />}>
            <TargetCommerceFlow />
          </ErrorBoundary>
        </TargetCartProvider>
      </div>
    </Sheet>
  )
}
